import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import Header from '../../components/Header'
import PedidoFinalizado from '../../components/PedidoFinalizado'

import * as S from '../../styles/checkout'
import { getLocalStorageLog } from '../../utils/traceLogAcessos'

const Finalizacao = () => {
  const [showModal, setShowModal] = useState(true)
  const { state } = useLocation()
  // console.log('state:', state)
  const pedidoConverted = state?.idPedido?.replace(/\D/gim, '')
  // console.log(pedidoConverted)
  // const store = useSelector((store) => store)
  // const pickedMethod = store.pagamento.pick

  const location = useLocation()
  
  useEffect(() => {
    if (state?.type === 'Boleto à vista') {
      window.open(
        `${process.env.REACT_APP_URL_MAIN}/bradesco/gerarboleto/?idpedido=${pedidoConverted}`
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    getLocalStorageLog(location.pathname)

    if (!!!state?.idPedido) {
      window.location.href = '/'
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  

  return (
    <>
      <Header onlylogo />

      <button
        style={{ marginLeft: '50vw', display: 'none', visibility: 'hidden' }}
        onClick={() => {
          setShowModal(true)
        }}
      >
        Abrir modal
      </button>

      <S.CheckoutSection>
        <PedidoFinalizado
          pedidoId={state?.idPedido}
          type={state?.type}
          valorST={state?.valorST}
          operacao={state?.operacao}
          // type={pickedMethod.id === 'boleto' ? 'boleto' : null}
        />
      </S.CheckoutSection>
    </>
  )
}
export default Finalizacao
